export default __webpack_public_path__ + "static/media/menu_inactive.37dfb193.svg";